import { MessageResponse } from "./messageResponse";

export class EquityReleaseRateResponse extends MessageResponse {
    age: number;
    percentage: number;
}
